import { Box } from "@mui/material"
import { useTheme } from '@mui/material/styles'

export const TimeIndicator = ({ top, ...restProps }: any) => {
  const theme = useTheme()

  return (
    <Box {...restProps}>
      <Box
        sx={{
          width: theme.spacing(1.5),
          height: theme.spacing(1.5),
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: theme.palette.primary.main
        }}
      />
      <Box
        sx={{
          height: '2px',
          borderTop: `2px ${theme.palette.primary.main} dotted`,
          width: '100%',
          transform: 'translate(0, -1px)'
        }}
      />
    </Box>
  )
}